import React from "react";
import { Element } from "react-scroll";
const ReactDOMServer = require("react-dom/server");
const HtmlToReactParser = require("html-to-react").Parser;

const VendorLearn = props => {
  const learnHTML = props.learn_tab.description;
  const htmlToReactParser = new HtmlToReactParser();
  const reactElement = htmlToReactParser.parse(learnHTML);
  const reactHtml = ReactDOMServer.renderToStaticMarkup(reactElement);
  return (
    <React.Fragment>
      <div className="learn_content_section">
        <div className="learn_content_block">
          <Element
            name="learn"
            className="learn"
          >{`More About ${props.category_name}`}</Element>

          <React.Fragment>{reactHtml ? reactElement : null}</React.Fragment>
        </div>
      </div>
    </React.Fragment>
  );
};

export default VendorLearn;
